import Navbar from "../components/Navbar";
import Footer from "../Footer";
import "./PolicyPages.css";

const mentorBenefits = [
  {
    number: "01",
    title: "Teach Practical Skills",
    description:
      "Help learners understand real-world technology through live sessions, practical guidance, projects, and structured learning.",
  },
  {
    number: "02",
    title: "Guide Learner Growth",
    description:
      "Review projects, answer technical questions, provide constructive feedback, and help learners strengthen their skills.",
  },
  {
    number: "03",
    title: "Build Your Professional Brand",
    description:
      "Share your expertise, strengthen your teaching profile, and contribute to a growing technology learning community.",
  },
  {
    number: "04",
    title: "Flexible Collaboration",
    description:
      "Mentoring opportunities may be structured around program requirements, availability, expertise, and learner needs.",
  },
];

const mentorRequirements = [
  "Strong knowledge of at least one relevant technology domain",
  "Practical project, software development, design, data, cloud, DevOps, or industry experience",
  "Ability to explain technical concepts clearly and patiently",
  "Professional communication and responsible learner interaction",
  "Commitment to scheduled sessions and agreed responsibilities",
  "Willingness to provide constructive feedback and practical guidance",
];

const mentorProcess = [
  {
    number: "01",
    title: "Send Your Profile",
    description:
      "Share your resume, LinkedIn profile, portfolio, GitHub profile, or other relevant professional information.",
  },
  {
    number: "02",
    title: "Profile Review",
    description:
      "The CODEION team reviews your skills, experience, subject expertise, and suitability for available mentoring opportunities.",
  },
  {
    number: "03",
    title: "Discussion",
    description:
      "Shortlisted applicants may be invited for a discussion, technical evaluation, teaching demonstration, or other selection step.",
  },
  {
    number: "04",
    title: "Start Mentoring",
    description:
      "Selected mentors receive information about the relevant program, responsibilities, schedule, learners, and collaboration terms.",
  },
];

function BecomeMentor() {
  return (
    <div className="opportunity-page">
      <Navbar />

      <main className="opportunity-main">
        <div className="opportunity-wrapper">
          <section className="opportunity-hero">
            <div className="opportunity-hero-content">
              <span className="legal-eyebrow">TEACH • GUIDE • INSPIRE</span>

              <h1>
                Become a Mentor at <span>CODEION</span>
              </h1>

              <p>
                Share your technical expertise, guide ambitious learners, and
                help students develop practical skills through projects,
                mentorship, and industry-focused learning.
              </p>

              <div className="opportunity-hero-actions">
                <a
                  className="support-primary-button"
                  href="mailto:careers@codeion.in?subject=CODEION%20Mentor%20Application"
                >
                  Apply as a Mentor →
                </a>

                <a
                  className="support-secondary-button"
                  href="#mentor-opportunity"
                >
                  Explore Opportunity ↓
                </a>
              </div>

              <div className="opportunity-hero-note">
                <span>✓</span>
                Applications are reviewed based on expertise, experience, and
                current program requirements.
              </div>
            </div>

            <div className="opportunity-highlight-card">
              <span className="opportunity-highlight-label">
                MENTOR OPPORTUNITIES
              </span>

              <h2>Help learners move from theory to practical skills.</h2>

              <div className="opportunity-highlight-list">
                <div>
                  <strong>Live Sessions</strong>
                  <span>Teach and explain technical concepts</span>
                </div>

                <div>
                  <strong>Project Reviews</strong>
                  <span>Give practical and constructive feedback</span>
                </div>

                <div>
                  <strong>Career Guidance</strong>
                  <span>Share relevant professional experience</span>
                </div>
              </div>
            </div>
          </section>

          <section id="mentor-opportunity" className="opportunity-section">
            <div className="support-section-heading">
              <span>WHY MENTOR WITH CODEION?</span>

              <h2>Make your experience valuable to learners</h2>

              <p>
                Contribute to practical technology education while strengthening
                your professional profile and helping learners grow.
              </p>
            </div>

            <div className="opportunity-card-grid">
              {mentorBenefits.map((benefit) => (
                <article className="opportunity-card" key={benefit.title}>
                  <div className="opportunity-card-number">
                    {benefit.number}
                  </div>

                  <h3>{benefit.title}</h3>

                  <p>{benefit.description}</p>
                </article>
              ))}
            </div>
          </section>

          <section className="opportunity-split-section">
            <div className="opportunity-info-panel">
              <span className="legal-eyebrow">WHO CAN APPLY?</span>

              <h2>We're looking for practitioners who enjoy teaching.</h2>

              <p>
                Mentor opportunities may be suitable for software engineers,
                developers, cloud and DevOps professionals, data and AI
                practitioners, designers, experienced trainers, educators, and
                other technology professionals.
              </p>

              <ul className="opportunity-check-list">
                {mentorRequirements.map((requirement) => (
                  <li key={requirement}>
                    <span>✓</span>
                    {requirement}
                  </li>
                ))}
              </ul>
            </div>

            <aside className="opportunity-side-card">
              <span className="opportunity-highlight-label">
                AREAS OF EXPERTISE
              </span>

              <h3>Technology domains may include</h3>

              <div className="opportunity-tags">
                <span>Frontend</span>
                <span>Backend</span>
                <span>Full Stack</span>
                <span>Java</span>
                <span>Python</span>
                <span>Cloud</span>
                <span>DevOps</span>
                <span>Data</span>
                <span>AI / ML</span>
                <span>UI / UX</span>
                <span>DSA</span>
                <span>Interview Prep</span>
              </div>

              <div className="legal-notice">
                Available mentor opportunities depend on current CODEION
                programs and learner requirements.
              </div>
            </aside>
          </section>

          <section className="opportunity-section">
            <div className="support-section-heading">
              <span>APPLICATION PROCESS</span>

              <h2>How mentor selection works</h2>

              <p>
                A simple process to understand your expertise and match suitable
                applicants with available opportunities.
              </p>
            </div>

            <div className="opportunity-process">
              {mentorProcess.map((step) => (
                <article className="opportunity-process-card" key={step.title}>
                  <span>{step.number}</span>

                  <h3>{step.title}</h3>

                  <p>{step.description}</p>
                </article>
              ))}
            </div>
          </section>

          <section className="opportunity-cta">
            <div>
              <span className="legal-eyebrow">JOIN THE CODEION COMMUNITY</span>

              <h2>Ready to share your expertise?</h2>

              <p>
                Send your professional profile, relevant experience, technology
                expertise, and availability to the CODEION team.
              </p>
            </div>

            <a
              className="support-primary-button"
              href="mailto:careers@codeion.in?subject=CODEION%20Mentor%20Application"
            >
              Apply as a Mentor →
            </a>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default BecomeMentor;